// Explore page. Both /analyze and /analyze/:sessionId route here; the
// underlying AnalyzeChat component handles the empty (no-session) state
// AND the active chat under one roof, so the composer-→-chat transition
// stays in place without a page swap.
import AnalyzeChat from "./AnalyzeChat";

export default function Analyze() {
  return <AnalyzeChat />;
}
